'use client'

import type { ReactNode } from 'react'

import parse from 'html-react-parser'
import styled from 'styled-components'

import tick from '@/assets/images/microsite/benefits/tick.svg'

export interface BenefitItemProps {
  title?: ReactNode
  /** May be an HTML string, which is parsed. */
  content?: ReactNode
  /** AOS animation delay (e.g. "200"). */
  delay?: string | number
  isActive?: boolean
  subtext?: ReactNode
}

const TickContainer = styled.div<{ $isActive?: boolean }>`
  position: relative;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  img {
    width: 16px;
    height: 16px;
    opacity: ${props => (props.$isActive ? 1 : 0.3)};
    transition: opacity 0.3s ease;
  }
`

const BenefitItem = ({ title, content, delay, isActive = true, subtext }: BenefitItemProps) => (
  <div className="position-relative z-0 d-flex gap-6 pl-1.5 md:gap-8">
    <div className="position-relative text-xs">
      <TickContainer $isActive={isActive}>
        <img src={tick.src} alt="" />
      </TickContainer>
    </div>
    <div data-aos="fade-left" data-aos-delay={delay}>
      <div className="mb-5 mx-4 mx-lg-5">
        <div className="text-section-row-title-v2 ">{title}</div>
        <div className="">{typeof content === 'string' ? parse(content) : content}</div>
        {subtext && <div className="text-section-row-title-subtext">{subtext}</div>}
      </div>
    </div>
  </div>
)

export default BenefitItem
